// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

/* Fix visible slider checkbox */
input {
  transform: scale(0.5);
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider::before {
  position: absolute;
  content: "";
  height: 26px;
  width: 28px;
  left: 0;
  bottom: 0;
  background-color: #ffffff;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: #2196f3;
}

input:checked + .slider::before,
input:checked + .slider > .emoji {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  display: flex;
  align-items: center;
}

.slider.round::before {
  border-radius: 50%;
  display: grid;
  place-items: center;
}

.slider::after {
  display: inline;
  position: absolute;
  right: 9.3%;
  bottom: 17.5%;
}

input:checked + .slider::after {
  display: inline;
  position: absolute;
  right: 56.3%;
  bottom: 14.5%;
}

.emoji {
  z-index: 10;
  display: flex;
  align-items: center;
  margin-left: 2px;
}

@media all and (max-width: 786px) and (min-width: 425px) {
  input:checked + .slider::after {
    right: 60.3%;
    bottom: 20.5%;
  }
  .slider::after {
    right: 15.3%;
    bottom: 22.5%;
  }
}
@media all and (max-width: 2560px) and (min-width: 1552px) {
  .slider::after {
    bottom: 12.5% !important;
  }
}
@media all and (max-width: 1552px) and (min-width: 1440px) {
  .slider::after {
    bottom: 7.5% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/ToggleSwitch/ToggleSwitch.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA,gCAAA;AACA;EACE,qBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBDCqB;ECCrB,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,yBDfc;ECiBd,gBAAA;AAEF;;AACA;EACE,yBDlBY;ACoBd;;AACA;EACE,mBDtBY;ACwBd;;AACA;;EAIE,2BAAA;AAEF;;AACA,oBAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAEF;;AACA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE;IACE,YAAA;IACA,aAAA;EAEF;EAAA;IACE,YAAA;IACA,aAAA;EAEF;AACF;AACA;EACE;IACE,wBAAA;EACF;AACF;AAEA;EACE;IACE,uBAAA;EAAF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n}\n\n/* Fix visible slider checkbox */\ninput {\n  transform: scale(0.5);\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: $toggleSwitchSliderBG;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider::before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 28px;\n  left: 0;\n  bottom: 0;\n  background-color: $textColorDark;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: $toggleCheck;\n}\n\ninput:focus + .slider {\n  box-shadow: $toggleCheck;\n}\n\ninput:checked + .slider::before,\ninput:checked + .slider > .emoji {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n  display: flex;\n  align-items: center;\n}\n\n.slider.round::before {\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n}\n\n.slider::after {\n  display: inline;\n  position: absolute;\n  right: 9.3%;\n  bottom: 17.5%;\n}\n\ninput:checked + .slider::after {\n  display: inline;\n  position: absolute;\n  right: 56.3%;\n  bottom: 14.5%;\n}\n\n.emoji {\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  margin-left: 2px;\n}\n\n@media all and (max-width: 786px) and (min-width: 425px) {\n  input:checked + .slider::after {\n    right: 60.3%;\n    bottom: 20.5%;\n  }\n  .slider::after {\n    right: 15.3%;\n    bottom: 22.5%;\n  }\n}\n\n@media all and (max-width: 2560px) and (min-width: 1552px) {\n  .slider::after {\n    bottom: 12.5% !important;\n  }\n}\n\n@media all and (max-width: 1552px) and (min-width: 1440px) {\n  .slider::after {\n    bottom: 7.5% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
